import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ReactiveService} from '../reactive-service.abstract';
import {map} from 'rxjs/operators';
import {ConfigApiService} from '../config/config-api.service';
import {OAUTH_CLIENTS} from '../config/config.interface';
import {trim} from '../../../../src/app/shared/helpers/string';


@Injectable()
export class SupersetApiService extends ReactiveService {


  baseUrl = '';

  constructor(private http: HttpClient, private configApiService: ConfigApiService) {
    super();

    this.configApiService.oauth2Clients.subscribe(res => {
      if (res[OAUTH_CLIENTS.superset]) {
        this.baseUrl = res[OAUTH_CLIENTS.superset];
      }
    });
    this.baseUrl = this.configApiService.oauth2Clients[OAUTH_CLIENTS.superset];
  }

  makeUrl(url) {
    return trim(this.baseUrl, '/') + '/' + trim(url, '/');
  }

  getAll() {
    this.updateData(this.http.get<any>(this.makeUrl(`/api/v1/dashboard/`), {withCredentials: true}).pipe(map(res => res.result)));
  }


  loadDashboard(id) {
    return this.http.get<any>(this.makeUrl(`/api/v1/dashboard/${id}/`), {withCredentials: true});
  }

}

